<template>
  <div class="search-input-group">
    <div v-if="displayErrors.length > 0" class="search-input-group__error">
      <p
        v-for="(errorMessage, index) in displayErrors"
        :key="index"
        class="search-input-group__error-message"
      >
        {{ errorMessage }}
      </p>
    </div>
    <div class="search-input-group__form">
      <SearchMinInput
        class="search-form__lower-budget"
        placeholder="下限なし"
        :has-error="hasLowerBudgetError"
        :default-value="lowerBudget"
        @inputted="onInputLowerBudget"
      />
      <div class="search-input-group__range-mark">
        〜
      </div>
      <SearchMinInput
        class="search-form__upper-budget"
        placeholder="上限なし"
        :has-error="hasHigherBudgetError"
        :default-value="higherBudget"
        @inputted="onInputHigherBudget"
      />
    </div>
  </div>
</template>

<script>
import SearchMinInput from './SearchMinInput.vue'

export default {
  components: {
    SearchMinInput
  },
  props: {
    lowerBudget: {
      required: true,
      validator: prop => typeof prop === 'number' || prop === null
    },
    higherBudget: {
      required: true,
      validator: prop => typeof prop === 'number' || prop === null
    },
    errors: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  computed: {
    displayErrors() {
      return Array.from(new Set(this.errors.map(error => error.message)))
    },
    hasLowerBudgetError() {
      return this.errors.some(error => error.attribute == 'lower_budget')
    },
    hasHigherBudgetError() {
      return this.errors.some(error => error.attribute == 'higher_budget')
    }
  },
  methods: {
    onInputLowerBudget(value) {
      this.$emit('inputted-lower-budget', value)
    },
    onInputHigherBudget(value) {
      this.$emit('inputted-higher-budget', value)
    }
  }
}
</script>
<style lang="scss" scoped>
.search-input-group {
  &__range-mark {
    font-size: 1.6rem;
    padding: 16px;
  }

  &__error {
    margin-bottom: 10px;

    &-message {
      font-size: 12px;
      line-height: 1.4;
      text-align: left;
      color: $danger;
    }
  }

  &__form {
    display: flex;
    align-items: center;
  }
}
</style>
